export default __webpack_public_path__ + "static/media/template_pro__0007_20---MatthiasEibinger.e26a862e.png";